import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Status, StatusIconComponent } from '@mode/capra';

@Component({
  standalone: true,
  selector: 'mode-status-banner',
  imports: [CommonModule, StatusIconComponent],
  templateUrl: './status-banner.component.html',
  styleUrls: ['./status-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusBannerComponent {
  @Input()
  status: Extract<Status, 'info' | 'warning'> = 'info';

  @Input()
  accent: '' | 'blue' = '';

  @Input() showIcon = true;

  @Input()
  layout: 'full-width' | 'inline' = 'inline';
}
